export const DATA_LAYER_SEARCH_CLICK = "click_search";
export const DATA_LAYER_SEARCH_TYPING = "typing_keyword_on_search";
export const DATA_LAYER_SEARCH_DEFAULT_CLICK = "click_default_search_section";
export const DATA_LAYER_SEARCH_QUICK_CLICK = "click_quick_search_section";
export const DATA_LAYER_SEARCH_RESULT_DIRECT = "direct_to_search_result";
export const DATA_LAYER_SEARCH_RESULT_CLICK = "click_search_result";
export const VIEW_SEARCH_RESULT_PAGE = "view_search_result_page";
export const FROM_SEARCH_QUICK = "fromquicksearchfds";
export const FROM_SEARCH_DEFAULT = "fromsearchdefaultfds";
